import { SignIn, SignUp } from "@clerk/react";
import { LOGO_URL } from "../lib/api";

const Shell = ({ children }) => (
  <div className="sky-bg flex flex-col items-center justify-center gap-6 px-4 py-10">
    <img src={LOGO_URL} alt="MIZUBINI" className="h-24 w-24 rounded-[24px] border-4 border-white shadow-lg" />
    {children}
  </div>
);

export const SignInPage = () => (
  <Shell><SignIn routing="path" path="/sign-in" signUpUrl="/sign-up" withSignUp fallbackRedirectUrl="/admin" /></Shell>
);

export const SignUpPage = () => (
  <Shell><SignUp routing="path" path="/sign-up" signInUrl="/sign-in" fallbackRedirectUrl="/admin" /></Shell>
);
